'use client';

import React, { useContext } from "react";
import { InstaIcon } from "../../components/icons/InstaIcon";
import FacebookIcon from "../../components/icons/FacebookIcon";
import TiktokIcon from "../../components/icons/TiktokIcon";
import { PlayStoreIcon } from "../icons/PlayStoreIcon";
import { Link } from "react-router-dom";
import AuthContext from "../../Context/auth/AuthContext";

export const Footer = () => {
  const { autenticado } = useContext(AuthContext);
  const socialData = [
    {
      name: "Instagram",
      link: "https://www.instagram.com/merrycoloroficial/",
      icon: <InstaIcon width={70} />,
      id: 1,
    },
    {
      name: "Facebook",
      link: "https://www.facebook.com/profile.php?id=100068529635739",
      icon: <FacebookIcon width={70} />,
      id: 2,
    },
    {
      name: "TikTok",
      link: "https://www.tiktok.com/@merrycolor.oficial",
      icon: <TiktokIcon width={70} />,
      id: 3,
    },
  ];

  const policies = [
    {
      name: "Terminos y condiciones",
      link: "/terms-and-conditions",
      auth: false,
    },
    {
      name: "Politicas de privacidad",
      link: "/policies-privacy.html",
      auth: false,
      external: true, // Custom flag to identify static links
    },
    {
      name: "Politicas de devolucion",
      link: "/policies-back",
      auth: false,
    },
    {
      name: "Terminos y condiciones",
      link: "/terminos-y-condiciones",
      auth: true,
    },
    {
      name: "Politicas de privacidad",
      link: "/politicas-privacidad",
      auth: true,
    },
    {
      name: "Politicas de devolucion",
      link: "/politicas-devolucion",
      auth: true,
    },
  ];

  return (
    <footer style={{ backgroundColor: "rgba(240, 192, 200, 0.92)" }} className="px-6 py-10 md:py-12">
      <div className="mx-auto w-full max-w-7xl">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">

          {/* Social Links */}
          <div className="flex flex-col items-center">
            <h3 className="mb-4 text-center text-sm font-bold tracking-wide text-[#802257] uppercase">
              Encuentra mas en nuestras redes sociales
            </h3>
            <div className="flex items-center justify-center gap-4">
              {socialData.map((social) => (
                <a
                  key={social.id}
                  href={social.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#802257] transition-colors duration-300 hover:text-[#801F56] hover:scale-110 transform"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          {/* QRS / App */}
          <div className="flex flex-col items-center">
            <h3 className="mb-4 text-center text-sm font-bold tracking-wide text-[#802257] uppercase">
              Consigue nuestra aplicacion
            </h3>
            <div className="grid grid-cols-2 gap-4">
              <div className="flex flex-col items-center gap-2">
                <img
                  src={require("../../assets/img/PlayStore.jpeg") || "/placeholder.svg"}
                  alt="Play Store QR"
                  className="h-24 w-24 rounded-lg object-cover shadow-md ring-1 ring-white/10"
                />
                <PlayStoreIcon width={40} />
              </div>
              <div className="flex flex-col items-center gap-2">
                <img
                  src={require("../../assets/img/AppStore.jpeg") || "/placeholder.svg"}
                  alt="App Store QR"
                  className="h-24 w-24 rounded-lg object-cover shadow-md ring-1 ring-white/10"
                />
                <img
                  src="https://1000marcas.net/wp-content/uploads/2020/11/App-Store-logo.png"
                  alt="App Store"
                  className="h-10 object-contain"
                />
              </div>
            </div>
          </div>

          {/* Logo + Policies */}
          <div className="flex flex-col items-center gap-4">
            <Link to="/">
              <img
                src={require("../../assets/img/MERRY COLOR D8708E.png") || "/placeholder.svg"}
                alt="Merry Color Logo"
                className="mx-auto max-h-20 object-contain transition-opacity duration-300 hover:opacity-80"
              />
            </Link>
            <div className="flex flex-wrap justify-center gap-x-4 gap-y-2">
              {policies
                .filter((policy) => policy.auth === autenticado)
                .map((policy) => (
                  policy.external ? (
                    <a
                      key={policy.link}
                      href={policy.link}
                      className="text-xs text-[#1876D2] transition-colors duration-200 hover:text-[#D8708E] hover:underline"
                    >
                      {policy.name}
                    </a>
                  ) : (
                    <Link
                      key={policy.link}
                      to={policy.link}
                      className="text-xs text-[#1876D2] transition-colors duration-200 hover:text-[#D8708E] hover:underline"
                    >
                      {policy.name}
                    </Link>
                  )
                ))}
            </div>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col gap-3">
            <h3 className="mb-1 text-sm font-bold tracking-wide text-[#802257] uppercase">
              Contacto
            </h3>
            <p className="flex items-start gap-2 text-sm leading-relaxed text-[#4a2035]">
              <svg className="mt-0.5 h-4 w-4 shrink-0 text-[#802257]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a2 2 0 01-2.828 0l-4.243-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              Calle Jose Maria Morelos, #673, Zona centro, Guadalajara, Jalisco C.P 44100
            </p>
            <Link
              to="tel:+525573626635"
              className="flex items-center gap-2 text-sm text-[#4a2035] transition-colors duration-200 hover:text-[#801F56]"
            >
              <svg className="h-4 w-4 shrink-0 text-[#802257]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              +52 56 1839 1680
            </Link>
            <Link
              to="mailto:merrycolor.oficial@gmail.com"
              className="flex items-center gap-2 text-sm text-[#4a2035] transition-colors duration-200 hover:text-[#801F56]"
            >
              <svg className="h-4 w-4 shrink-0 text-[#802257]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              merrycolor.oficial@gmail.com
            </Link>
            <Link
              to="mailto:merrycolorventas@gmail.com"
              className="flex items-center gap-2 text-sm text-[#4a2035] transition-colors duration-200 hover:text-[#801F56]"
            >
              <svg className="h-4 w-4 shrink-0 text-[#D8708E]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              merrycolorventas@gmail.com
            </Link>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="mt-10 border-t border-[#802257]/20 pt-6 text-center">
          <p className="text-xs text-[#802257]/70">
            &copy; {new Date().getFullYear()} All rights reserved.{" "}
            <Link
              to="https://digital-pineapple.com.mx"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-[#802257] transition-colors duration-200 hover:text-[#801F56]"
            >
              digital-pineapple.com.mx
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};
